/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SendMailSimulationRecapMutation($input: SendMailWithDocuments_M_simulation_recapInput!) {
    sendMailSimulationRecap_M_simulation_recap(input: $input) {
      ok
      error
      
        errorDuringUpload 
        canSendMail 
    }
  }
`;

export default mutation;
